module.exports = __webpack_public_path__ + "public/SiteIcons/moreDecline.svg?1535dd31";